<template>
<div>
    <button class="kt-aside-close " id="kt_aside_close_btn"><i class="la la-close"></i></button>
    <div class="kt-aside  kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop" id="kt_aside">

        <!-- begin:: Aside Menu -->
        <div class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper">
            <div id="kt_aside_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1">
                <ul class="kt-menu__nav">
                    <li
                    v-bind:key="index"
                    v-for="(item, index) in items"
                    v-bind:class="{
                        'kt-menu__section--first' : item.is_navigation === true && index === 0,
                        'kt-menu__section' : item.is_navigation === true,
                        'kt-menu__item' : item.is_navigation === false,
                        'kt-menu__item--submenu': item.submenu.length > 0,
                        'kt-menu__item--open': item.submenu.find(o => o.url === $router.history.current.path)
                    }"
                    :data-ktmenu-submenu-toggle="item.submenu.length > 0 ? 'hover' : ''"
                    >
                        <h4 v-if="item.is_navigation === true" class="kt-menu__section-text">
                            {{ item.navigation }}
                        </h4>

                        <div v-if="item.submenu.length > 0" class="kt-menu__link kt-menu__toggle">
                            <i v-if="item.icon" class="kt-menu__link-icon" v-bind:class="item.icon"></i>
                            <span class="kt-menu__link-text">{{ item.name }}</span>
                            <span v-if="($can('read', 'open-banking')) &&
                                item.name === open_banking && countData.PendingApplications > 0"
                                  class="badge badge-pill badge-success m-1 px-2  text-center">
                                {{countData.PendingApplications}}
                            </span>
                            <span v-if="getOtherGatewaysCountData() > 0 && ($can('read', 'ipg-gateway')) &&
                                item.name === other_gateway_manage"
                                  class="badge badge-pill badge-success m-1 px-2 text-center">
                                {{getOtherGatewaysCountData()}}
                            </span>
                            <span v-if="getSettingsCountData() > 0 &&
                                item.name === settings"
                                  class="badge badge-pill badge-success m-1 px-2 text-center">
                                {{getSettingsCountData()}}
                            </span>
                            <i class="kt-menu__ver-arrow la la-angle-left"></i>
                        </div>
                        <router-link
                        v-else
                            class="kt-menu__link"
                            v-bind:to="item.url"
                            :exact="item.exact ? true :false"
                        >
                            <i v-if="item.icon" class="kt-menu__link-icon" v-bind:class="item.icon"></i>
                            <span class="kt-menu__link-text">{{ item.name }}</span>
                            <span v-if="item.badge" class="kt-menu__link-badge">
                                <span v-bind:class="'kt-badge kt-badge--' + item.badge_type">
                                        {{ item.badge }}
                                </span>
                            </span>
                            <span v-if="($can('read-general-info', 'user')) &&
                                item.name === aside_users && countData.authPendingUsers > 0"
                                  class="badge badge-pill badge-success m-1 px-2  text-center">
                                {{countData.authPendingUsers}}
                            </span>
                            <span v-else-if="($can('read-general-info', 'user')) &&
                                item.name === aside_stakeholders && countData.PendingStakeholders > 0"
                                  class="badge badge-pill badge-success m-1 px-2  text-center">
                                {{countData.PendingStakeholders}}
                            </span>
                            <span v-else-if="($can('read', 'ipg-gateway')) &&
                                item.name === aside_bank_gateways && countData.PendingBankGateways > 0"
                                  class="badge badge-pill badge-success m-1 px-2  text-center">
                                {{countData.PendingBankGateways}}
                            </span>
                            <span v-else-if="($can('read', 'ipg-gateway')) &&
                                item.name === other_gateway_manage && countData.otherGateways > 0"
                                  class="badge badge-pill badge-success m-1 px-2  text-center">
                                {{countData.otherGateways}}
                            </span>
                            <span v-else-if="($can('read', 'ticket')) &&
                                item.name === aside_tickets && countData.PendingTicketsWithManageAccess > 0"
                                  class="badge badge-pill badge-danger m-1 px-2 py-1 text-center">
                                {{countData.PendingTicketsWithManageAccess}}
                            </span>
                            <span v-else-if="!($can('read', 'ticket')) &&
                                item.name === aside_tickets && openUserTicketsNo > 0"
                                  class="badge badge-pill badge-danger m-1 px-2 py-1 text-center">
                                {{openUserTicketsNo}}
                            </span>
                            <span v-else-if="($can('read', 'ipg-gateway')) &&
                                item.name === shaparak_requests && countData.creatadShaparakRequest > 0"
                                  class="badge badge-pill badge-success m-1 px-2  text-center">
                                {{countData.creatadShaparakRequest}}
                            </span>
                            <span v-else-if="($can('read', 'open-banking')) &&
                                item.name === open_banking && countData.PendingApplications > 0"
                                  class="badge badge-pill badge-success m-1 px-2  text-center">
                                {{countData.PendingApplications}}
                            </span>
                        </router-link>
                        <div v-if="item.submenu.length > 0"
                            class="kt-menu__submenu">
                            <span class="kt-menu__arrow"></span>
                            <ul class="kt-menu__subnav">
                                <li v-bind:key="index" v-for="(submenu, index) in item.submenu"
                                    class="kt-menu__item"
                                    aria-haspopup="true">
                                    <router-link v-bind:to="submenu.url" class="kt-menu__link">
                                        <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                            <span></span>
                                        </i>
                                        <span class="kt-menu__link-text">{{ submenu.name }}</span>
                                        <span v-if="($can('read', 'ipg-gateway')) &&
                                            submenu.name === aside_payman && countData.PendingPaymanGateways > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingPaymanGateways}}
                                        </span>
                                        <span v-else-if="($can('read', 'ivr-gateway')) &&
                                            submenu.name === aside_ivr && countData.PendingIVRGateways > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingIVRGateways}}
                                        </span>
                                        <span v-else-if="($can('read', 'ipg-gateway')) &&
                                            submenu.name === aside_dedicated && countData.PendingDedicatedGateways > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingDedicatedGateways}}
                                        </span>
                                        <span v-else-if="($can('read', 'ipg-gateway')) &&
                                            submenu.name === aside_collective && countData.PendingCollectiveGateways > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingCollectiveGateways}}
                                        </span>
                                        <span v-else-if="($can('read', 'deposit-gateway')) &&
                                            submenu.name === aside_deposit_pf && countData.PendingPfDepositGateways > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingPfDepositGateways}}
                                        </span>
                                        <span v-else-if="($can('read', 'deposit-gateway')) &&
                                            submenu.name === deposit_starshop && countData.PendingStarshopDepositGateways > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingStarshopDepositGateways}}
                                        </span>
                                        <span v-else-if="($can('read', 'card-to-card-gateway')) &&
                                            submenu.name === aside_card_to_card && countData.PendingCardToCardGateways > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingCardToCardGateways}}
                                        </span>
                                        <span v-else-if="($can('read', 'open-banking')) &&
                                            submenu.name === applications && countData.PendingApplications > 0"
                                              class="badge badge-pill badge-success m-1 px-2  h-50 text-center">
                                            {{countData.PendingApplications}}
                                        </span>
                                        <span v-else-if="($can('read', 'contract-manager')) &&
                                            submenu.name === online_contract && countData.EndedOnlineContracts > 0"
                                              class="badge badge-pill badge-success m-1 px-2 h-50 text-center">
                                            {{countData.EndedOnlineContracts}}
                                        </span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- end:: Aside Menu -->
    </div>
</div>
</template>

<script>
import { KTLayout } from '@/plugins/layout'
import aside from '@/common/aside'
import {mapGetters} from "vuex";
import { i18n } from '@/plugins/i18n'
import store from "@/store";

export default {
    props: {
        aside_users: {
            default() {
                return i18n.t('aside.users')
            },
        },
        aside_stakeholders: {
            default() {
                return i18n.t('aside.stakeholders')
            },
        },
        aside_bank_gateways: {
            default() {
                return i18n.t('aside.bank_gateways')
            },
        },
        aside_payman: {
            default() {
                return  i18n.t('aside.payman')
            },
        },
        aside_ivr: {
            default() {
                return  i18n.t('aside.ivr')
            },
        },
        aside_dedicated: {
            default() {
                return  i18n.t('aside.dedicated')
            },
        },
        aside_collective: {
            default() {
                return  i18n.t('aside.collective')
            },
        },
        aside_deposit_pf: {
            default() {
                return  i18n.t('aside.deposit_pf')
            },
        },
        deposit_starshop: {
            default() {
                return  i18n.t('aside.deposit_starshop')
            },
        },
        aside_card_to_card: {
            default() {
                return  i18n.t('aside.card_to_card')
            },
        },
        aside_tickets: {
            default() {
                return  i18n.t('aside.tickets')
            },
        },
        other_gateway_manage: {
            default() {
                return  i18n.t('aside.other_gateway_manage')
            },
        },
        open_banking: {
            default() {
                return  i18n.t('aside.open_banking')
            },
        },

        applications: {
            default() {
                return  i18n.t('aside.applications')
            },
        },
        shaparak_requests: {
            default() {
                return  i18n.t('aside.shaparak_requests')
            },
        },
        online_contract: {
            default() {
                return  i18n.t('aside.online_contracts')
            },
        },
        settings: {
            default() {
                return  i18n.t('aside.settings')
            },
        },
    },
    data() {
        return {
            menu: []
        }
    },
    computed: {
        store() {
            return store
        },
        items () {
            return this.menu
        },
        ...mapGetters('badgeCounter', [
            'countData',
            'openUserTicketsNo'
        ])
    },
    methods: {
        checkPermissions(rules) {
            if (Object.keys(rules).length < 1) {
                return true;
            }
            let hasPermission = false;
            Object.keys(rules).forEach(subject => {
                if (rules[subject].some(permission => this.$can(permission, subject))) {
                    hasPermission = true;
                }
            });

            return hasPermission;
        },
        processMenuPermissions(menuItems) {
            return menuItems.map(element => {
                if (element.rules) {
                    if ( this.checkPermissions(element.rules)) {
                        return element
                    }

                    return false;
                }

                if (element.submenu && element.submenu.length > 0) {
                    element.submenu = element.submenu.filter(submenuItem => {
                        if (submenuItem.rules) {
                            return this.$can(submenuItem.rules[Object.keys(submenuItem.rules)[0]], Object.keys(submenuItem.rules)[0]);
                        }
                        return true;
                    });

                    if (element.submenu.length === 0) {
                        return false
                    }
                }

                return element;
            }).filter(element => element !== false);
        },
        matchUrl (uri) {
            return this.$router.matcher.match(uri).matched.length > 0
        },
        getOtherGatewaysCountData() {
            let sum_gateway_count = 0;
            if (this.$can('read', 'ipg-gateway')) {
                sum_gateway_count = this.countData.PendingPaymanGateways +
                    this.countData.PendingIVRGateways +
                    this.countData.PendingDedicatedGateways +
                    this.countData.PendingCollectiveGateways
            }
            if (this.$can('read', 'card-to-card-gateway')) {
                sum_gateway_count += this.countData.PendingCardToCardGateways
            }
            if (this.$can('read', 'deposit-gateway')) {
                sum_gateway_count += this.countData.PendingDepositPfGateways
            }

            return sum_gateway_count;
        },
        getSettingsCountData() {
            let sum_setting_count = 0;

            if (this.$can('read', 'contract-manager')) {
                sum_setting_count += this.countData.EndedOnlineContracts
            }

            return sum_setting_count;
        }
    },
    mounted() {
        KTLayout.initAside()
        this.menu = this.processMenuPermissions(aside);
        this.$store.dispatch('badgeCounter/countData')
        this.$store.dispatch('badgeCounter/countUserTickets')
    }
}
</script>

<style scss>
.kt-aside-menu {
    overflow-y: auto!important;
}
.router-link-active span,.router-link-active .kt-menu__link-icon,.router-link-exact-active span,.router-link-exact-active .kt-menu__link-icon{
    color: #5d78ff!important;
}
</style>